import { StickyPanelPlacement as BasicStickyPanelPlacement } from '@wix/extensions-slots-host';
import { withEditorSlotsState } from '../withEditorSlotsState';

export const StickyPanelPlacement = withEditorSlotsState(
  BasicStickyPanelPlacement,
);
